import React from 'react';
import Slider from 'react-slick';
import Test_1 from '../../../assets/images/testimonial/testimonial-qoute-four.svg';
import Test_2 from '../../../assets/images/testimonial/testiomonial-four-1.png';
import Test_3 from '../../../assets/images/testimonial/testiomonial-four-2.png';
import Test_4 from '../../../assets/images/testimonial/testiomonial-four-3.png';

const Testimonial = () => {
    return (
        <>
            <div className="testimonial-section-four">
                <div className="container">
                    <Slider className="myswiper">
                        <div className="testimonial-item-four">
                            <div className="testimonial-box-four">
                                <img
                                    src={Test_1}
                                    alt="icon"
                                />
                                <div className="testimonial-image-four">
                                    <img
                                        src={Test_2}
                                        alt="testimonial-image"
                                    />
                                </div>
                                <div className="testimonial-details-four">
                                    <div className="testimonial-title-four">
                                        <h4>John Doue</h4>
                                        <p>Digital marketing</p>
                                    </div>
                                    <p>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                        vulputate eu felis It should go without saying that imperdiet
                                        proin nulla aliquet enim.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-item-four">
                            <div className="testimonial-box-four">
                                <img
                                    src={Test_1}
                                    alt="icon"
                                />
                                <div className="testimonial-image-four">
                                    <img
                                        src={Test_3}
                                        alt="testimonial-image"
                                    />
                                </div>
                                <div className="testimonial-details-four">
                                    <div className="testimonial-title-four">
                                        <h4>James Stevens</h4>
                                        <p>E-commerce Business </p>
                                    </div>
                                    <p>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                        vulputate eu felis It should go without saying that imperdiet
                                        proin nulla aliquet enim.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-item-four">
                            <div className="testimonial-box-four">
                                <img
                                    src={Test_1}
                                    alt="icon"
                                />
                                <div className="testimonial-image-four">
                                    <img
                                        src={Test_4}
                                        alt="testimonial-image"
                                    />
                                </div>
                                <div className="testimonial-details-four">
                                    <div className="testimonial-title-four">
                                        <h4>Sarah Williams</h4>
                                        <p>Corporate Client</p>
                                    </div>
                                    <p>
                                        Vulputate mi sit amet mauris commodo quis imperdiet. Metus
                                        vulputate eu felis It should go without saying that imperdiet
                                        proin nulla aliquet enim.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Testimonial
